/**
 * Layout constants for sidebar and main content.
 * Use these in Sidebar and WebLayout so widths stay in sync.
 */
export const SIDEBAR_WIDTH_COLLAPSED = 72;
export const SIDEBAR_WIDTH_EXPANDED = 240;
